
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"464pt","viewBox":"0 0 464 464","width":"464pt","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M160 0C71.602 0 0 60.879 0 136a121.28 121.28 0 0028.398 77.2L0 288l78.96-34.719a177.915 177.915 0 0069.68 18.32c3.758.32 7.52.399 11.36.399 75.281 0 138.32-44.16 155.36-103.602A114.844 114.844 0 00320 136C320 60.879 248.398 0 160 0zm25.84 170.703A34.011 34.011 0 01160 184c-22.09 0-40-25.07-40-56s17.91-56 40-56 40 25.07 40 56a66.751 66.751 0 01-14.16 42.703zm0 0","fill":"#009698"}}),_c('path',{attrs:{"d":"M185.84 170.703L168 160l17.84 10.703A66.751 66.751 0 00200 128c0-30.93-17.91-56-40-56s-40 25.07-40 56 17.91 56 40 56a34.011 34.011 0 0025.84-13.297zm0 0","fill":"#009698"}}),_c('path',{attrs:{"d":"M464 304c0-71.84-65.52-130.719-148.64-135.602C298.32 227.84 235.28 272 160 272c-3.84 0-7.602-.078-11.36-.398A114.844 114.844 0 00144 304c0 75.121 71.602 136 160 136a181.628 181.628 0 0074.8-15.762L464 464l-33.121-77.2A122.532 122.532 0 00464 304zm0 0M212.121 177.145l-14.84-8.907A77.833 77.833 0 00208 128c0-35.29-21.527-64-48-64s-48 28.71-48 64 21.527 64 48 64a40.006 40.006 0 0027.09-11.2l16.797 10.071a8.001 8.001 0 008.242-13.71zM160 176c-17.344 0-32-21.984-32-48s14.656-48 32-48 32 21.984 32 48a62.39 62.39 0 01-8.434 32l-11.445-6.863a8.001 8.001 0 00-8.242 13.71l8.617 5.169A22.61 22.61 0 01160 176zm0 0","fill":"#ffcd00"}}),_c('path',{attrs:{"d":"M351.535 373.313l-40-112a7.997 7.997 0 00-15.07 0l-40 112a7.999 7.999 0 004.848 10.222 7.999 7.999 0 0010.222-4.847L283.93 344h40.14l12.395 34.688A7.997 7.997 0 00344 384c2.602 0 5.04-1.266 6.54-3.39s1.87-4.848.995-7.297zM289.641 328L304 287.785 318.398 328zm0 0","fill":"#009698"}})])
          )
        }
      }
    